export default {
  resetLabel: 'Clear refinements',
};



// WEBPACK FOOTER //
// ./src/widgets/clear-refinements/defaultTemplates.js